<template lang="pug">
div
  template(v-if="isReadOnly")
    v-text-field.x-widget.x-widget-readonly(
      v-model="content"
      v-bind="$attrs"
      ref="input"
      readonly
      filled
      :type="myType"
      :label="myTitle"
      :hint="myHint"
      :dense="!isLarge"
      :autocomplete="myAutoComplete"
      :hide-details="hasNoHints"
      :rules="rules"
      :prepend-inner-icon="myIcon"
      :readonly="isReadOnly"
      :required="isRequired && !isDisabled"
      :append-icon="metaIcon"
      @click:append="revealed = !revealed"
      @keyup.enter="$emit('action-performed', $refs.input)"
    )
  template(v-else)
    vuetify-number.x-widget(
      v-if="!allowsMany"
      v-model.number="content"
      v-bind="$attrs"
      ref="input"
      :options="options"
      :class="{ 'x-widget-readonly': isReadOnly }"
      :type="myType"
      :label="myTitle"
      :hint="myHint"
      :dense="!isLarge"
      :autocomplete="myAutoComplete"
      :hide-details="hasNoHints"
      :rules="rules"
      :prepend-inner-icon="myIcon"
      :readonly="isReadOnly"
      :required="isRequired && !isDisabled"
      :disabled="isDisabled"
      :append-icon="metaIcon"
      @click:append="revealed = !revealed"
      @keyup.enter="$emit('action-performed', $refs.input)"
    )

  //- //- Ainda não suportamos muitos no campo numérico, por isso, estamos deixando o usuário livre.
  //- v-text-field.x-widget(
  //-   v-else
  //-   v-model="content"
  //-   v-bind="$attrs"
  //-   ref="input"
  //-   filled
  //-   :label="myTitle"
  //-   :hint="myHint"
  //-   :dense="!isLarge"
  //-   :autocomplete="myAutoComplete"
  //-   :hide-details="hasNoHints"
  //-   :rules="rules"
  //-   :prepend-inner-icon="myIcon"
  //-   :readonly="isReadOnly"
  //-   :required="isRequired && !isDisabled"
  //-   :append-icon="metaIcon"
  //-   @click:append="revealed = !revealed"
  //-   @keyup.enter="$emit('action-performed', $refs.input)"
  //- )
</template>

<style>
.x-widget .white {
  background-color: #ffffff00 !important;
}
.x-widget-readonly fieldset {
  border: none;
}
</style>

<script>
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { interpolate, isInterpolated } from '@/helpers/strings'

export default {
  aliases: [ 'WidgetInteger', 'WidgetLong', 'WidgetDecimal' ],

  props: {
    /**
     * Objeto contendo os valores e campos do contexto no qual o widget está
     * inserido para inferência de propriedades aplicadas em interpolação de
     * templates de texto.
     */
    context: Object,

    /**
     * Instância opcional de um campo do Paper.
     * @type {Keep.Paper.Design.Field}
     */
    field: Object,

    /**
     * Um dos tipos de dados suportados pelo Paper.
     * @type {Keep.Paper.Design.TypeNames}
     */
    dataType: String,

    /**
     * Diz se o componente suporta seleção de intervalo.
     * @type {Boolean}
     */
    allowRange: Boolean,

    /**
     * Valor editado no componente.
     * @type {Any}
     */
    value: {
      validator: v => true
    },
  },

  data: () => ({
    icons: {
      mdiEyeOutline,
      mdiEyeOffOutline,
    },

    revealed: false,
  }),

  computed: {
    myName: vm => vm.getIt('name'),
    myTitle: vm => vm.getIt('title') || vm.myName,
    myDescription: vm => vm.getIt('description'),
    myHint: vm => vm.getIt('hint'),
    myPlaceholder: vm => vm.getIt('placeholder'),
    isSecure: vm => vm.hasIt('secure'),
    isLarge: vm => vm.hasIt('large'),
    hasNoHints: vm => vm.hasIt('noHints'),
    isDisabled: vm => vm.hasIt('disabled'),
    isRequired: vm => vm.hasIt('required'),
    isReadOnly: vm => vm.hasIt('readOnly') || vm.hasIt('readonly'),
    allowsMany: vm => vm.hasIt('allowMany'),
    myIcon: vm => vm.getIt('icon'),

    myType () { return this.isSecure && !this.revealed ? 'password' : 'number' },
    myAutoComplete () {
      if (this.myName?.toLowerCase() === 'username') return 'username'
      if (this.myName?.toLowerCase() === 'password') return 'current-password'
      return null
    },

    metaIcon () {
      if (!this.isSecure) return null
      return this.revealed ? this.icons.mdiEyeOffOutline : this.icons.mdiEyeOutline
    },

    myDataType() {
      return this.field?.dataType || this.dataType
    },

    isDecimal() {
      return this.myDataType === 'Decimal' || this.myDataType === 'Currency'
    },

    myPrecision() {
      if (this.field?.precision) return this.field.precision
      return this.isDecimal ? 2 : 0
    },

    options() {
      return {
        locale: "pt-BR",
        prefix: this.myDataType === 'Currency' ? 'R$' : '',
        // suffix: "",
        // length: 9,
        precision: this.myPrecision,
      }
    },

    content: {
      get () {
        return this.value || null
      },
      set (value) {
        this.$emit('input', value || null)
      }
    },

    rules () {
      const required = (this.isRequired && !this.isDisabled)
      return [
        v => !required || !!v || 'Campo requerido',
        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ]
    },
  },

  methods: {
    getIt (property) {
      return this[property]
        || this.$props[property]
        || this.$attrs[property]
        || this.field?.[property]
    },
    hasIt (property) {
      if (this.$props[property] === '') return true
      if (this.$attrs[property] === '') return true
      const value = this[property]
        || this.$props[property]
        || this.$attrs[property]
        || this.field?.[property]
      return !!value
    },

    format(text) {
      return isInterpolated(text) ? interpolate(text, this.context) : text
    },
  },
}
</script>